import t from "../helpers/t";
import { useState } from "react";
import ComboSelectItem from "./comboselectitem";
import { Item, Menu, Separator, useContextMenu } from "react-contexify";
import "react-contexify/dist/ReactContexify.css";

const ComboSelect = ({
  label = null,
  placeholder = null,
  onClickedHandler,
  onRemoveHandler,
  onItemSearchChanged,
  onItemSearchBlur,
  itemResultsHidden,
  onItemsSelectHandle,
  selectedItems,
  allItems,
  valkey,
  valprop,
  extraAmount = false,
  onExtraAmountChange = null,
  amountValue = null,
  amountLabel = "",
  short = false,
  contextMenu = false,
  menuId = null,
  contextMenuItems = null,
  contextFunctions = null,
}: any) => {
  const onFocusOut = (e: any) => {
    /*if(!contextMenu){
            return;
        }
        let elem = e.target.parentNode.parentNode;
        elem.classList.remove('select2-container--focus');
        let y = document.getElementsByClassName('inb-c-popup-window');
        let aNode = y[0];
        aNode.parentNode.removeChild(aNode);*/
  };
  const [currentId, setCurrentId] = useState(null);
  const { show } = useContextMenu({
    id: menuId,
  });

  function handleContextMenu(event: any) {
    if (!contextMenu) return;
    let id = event.target.id;
    if (event.target.nodeName === "SPAN") {
      id = event.target.parentNode.id;
    }
    setCurrentId(id);
    show({
      event: event,
      props: {
        key: "value",
      },
      /*position: {
                x: MousePosition.x,
                y: (MousePosition.y+1000),
            }*/
    });
  }
  const go = (id: any) => {
    contextFunctions(id, currentId);
  };
  return (
    <>
      <div className="inb-form-group column medium-12 small-12 _backform_userfroups">
        {label !== null && (
          <>
            <label className="inb-form__controlLabel">{label}</label>
          </>
        )}
        <div className="inb-form__controllClass">
          <span
            className={
              "select2 select2-container select2-container--default " +
              (contextMenu ? "select2-container--disabled" : "select2-container--focus")
            }
            onBlur={onFocusOut}
            dir="ltr"
            data-select2-id="2"
            style={{ width: "auto" }}
          >
            <span className="selection">
              <span
                className="select2-selection select2-selection--multiple"
                role="combobox"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex={-1}
              >
                <ul className="select2-selection__rendered" onClick={onClickedHandler}>
                  {selectedItems.map((item: any, index: any) => {
                    if (typeof item[valkey] !== "undefined") {
                      return (
                        <>
                          <ComboSelectItem
                            item={item}
                            value={item[valprop]}
                            id={item[valkey]}
                            index={index}
                            onRemoveHandler={onRemoveHandler}
                            extraAmount={extraAmount}
                            onExtraAmountChange={onExtraAmountChange}
                            amountValue={
                              typeof amountValue[item[valkey]] !== "undefined"
                                ? amountValue[item[valkey]]
                                : null
                            }
                            amountLabel={amountLabel}
                            disabled={item.disabled}
                            short={short}
                            contextMenu={contextMenu}
                            //onContext={onContext}
                            handleContextMenu={handleContextMenu}
                          />
                        </>
                      );
                    }
                  })}
                  {contextMenu && (
                    <>
                      <Menu id={menuId}>
                        {contextMenuItems.map((option: any, k: any) => {
                          return (
                            <>
                              <Item id={option.onClick} onClick={go}>
                                {option.label}
                              </Item>
                              {k + 1 !== contextMenuItems.length && (
                                <>
                                  <Separator />
                                </>
                              )}
                            </>
                          );
                        })}
                      </Menu>
                    </>
                  )}
                  <li
                    className="select2-search select2-search--inline"
                    style={{ paddingTop: "5px" }}
                  >
                    <input
                      className="select2-search__field2"
                      type="search"
                      tabIndex={0}
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="none"
                      spellCheck="false"
                      role="textbox"
                      aria-autocomplete="list"
                      placeholder={placeholder !== null ? placeholder : t("switch")}
                      onChange={onItemSearchChanged}
                      onBlur={onItemSearchBlur}
                    />
                  </li>
                </ul>
              </span>
            </span>
            {contextMenu && <span className="dropdown-wrapper" aria-hidden="true"></span>}
            {!short && (
              <ul
                className={
                  "inbooma-select-box-results" + (itemResultsHidden === true ? " hide" : "")
                }
                style={{ width: "100%" }}
              >
                {allItems.map((item: any) => {
                  return (
                    <li
                      className={"inbooma-select-box-results__field"}
                      key={item[valkey]}
                      value={item[valkey]}
                      onClick={(e) => {
                        onItemsSelectHandle(e, item);
                      }}
                    >
                      <span style={{ width: "100%" }}>{item[valprop]}</span>
                    </li>
                  );
                })}
              </ul>
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default ComboSelect;
